export default "__VITE_ASSET__DdgiELrJ__"